import React from "react";
import Icon from "@/components/icons/Icons";
import { Plan, RetirementPlanCardData } from "@/type/financialPageTypes";
import RibbonSVG from "./RibbonSVG";

export default function RetirementPlanCard({
  plan,
  selectedPlan,
  onSelect,
  isPostRetirement,
}: {
  plan: RetirementPlanCardData;
  selectedPlan: Plan;
  onSelect: (id: NonNullable<Plan>) => void;
  isPostRetirement?: boolean;
}) {
  const isSelected = selectedPlan === plan.id;
  const hasSelection = selectedPlan !== null;

  return (
    <button
      onClick={() => onSelect(plan.id)}
      className={[
        "relative shrink-0 w-full max-w-58 rounded-4xl bg-linear-to-b/srgb",
        "p-4 pb-8 text-left transition border focus:outline-hidden",
        plan.border,
        hasSelection
          ? !isSelected
            ? "md:hover:shadow-md md:hover:scale-[1.02] opacity-50"
            : "opacity-100"
          : "md:hover:shadow-md md:hover:scale-[1.02]",
      ].join(" ")}
      style={{ background: plan.bgColor }}
    >
      <span
        className={[
          "absolute top-3 left-3.5 w-4 h-4 rounded-full text-white flex items-center justify-center",
          isSelected ? "bg-[#20D000]" : "border-2 border-[#494953]",
        ].join(" ")}
      >
        {isSelected && <Icon.rightSignIcon className="w-3 h-3" />}
      </span>

      <div className="text-center">
        <p
          className={[
            "bg-clip-text text-transparent text-2xs xl:text-sm font-medium uppercase",
            isPostRetirement ? "mb-1" : "mb-2",
            plan.labelColor,
          ].join(" ")}
        >
          {plan.label}
        </p>
        <p
          className={[
            "text-xl xl:text-1.5xl xl:leading-7.5 leading-1.3 font-bold text-black",
            isPostRetirement ? "mb-2" : "mb-1.5",
          ].join(" ")}
        >
          {plan.corpusText}
        </p>
        {!isPostRetirement && (
          <p className="text-2xs xl:text-sm font-medium text-[#666666] mb-2.5">
            Corpus
          </p>
        )}
      </div>

      <div className="space-y-2.5">
        {plan.rows.map((r) => (
          <div
            key={r.label}
            className="flex justify-between text-2xs xl:text-sm xl:leading-5 leading-1.2"
          >
            <span className="text-black">{r.label}</span>
            <span className="font-semibold text-right text-[#003D6C]">
              {r.value}
            </span>
          </div>
        ))}
      </div>

      <div className="absolute inset-x-0 bottom-0 translate-y-1/2 mx-auto text-center">
        <p className="absolute z-1 inset-x-0 top-1 text-xs leading-1.2 font-medium tracking-[-3%] text-white/90">
          Total Withdrawal :{" "}
          <span className="font-semibold text-white">{plan.withdrawal}</span>
        </p>
        <RibbonSVG className="relative z-0 block mx-auto" />
      </div>
    </button>
  );
}
